import React, { useState } from "react";
import {
  Select,
  MenuItem,
  FormControl,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import { StatusType } from "../../../models/Shipments";

interface DropdownProps {
  open: boolean;
  data: StatusType[];
  onStatusDropdownSelect: (id: number) => void;
  onClose: () => void;
}

const ShipmentStatusPopup: React.FC<DropdownProps> = ({
  open,
  data,
  onStatusDropdownSelect,
  onClose,
}) => {
  const [status, setStatus] = useState<number>(-1);

  const handleSave = () => {
    onStatusDropdownSelect(status);
    onClose();
  };

  const handleCancel = () => {
    setStatus(-1);
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleCancel}>
      <DialogTitle>Select Status</DialogTitle>
      <DialogContent
        sx={{
          minWidth: "400px",
        }}
      >
        <FormControl fullWidth>
          <Select
            labelId="status-label"
            id="status"
            name="status"
            value={status || -1}
            onChange={(e) => setStatus(e.target.value as number)}
            MenuProps={{
              PaperProps: {
                style: {
                  maxHeight: 150,
                  overflowY: "auto",
                },
              },
            }}
          >
            <MenuItem key="status-default-value" value={-1}>
              None
            </MenuItem>
            {data.map((status) => (
              <MenuItem key={status.id} value={status.id}>
                {status.value}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCancel} color="secondary">
          Cancel
        </Button>
        <Button
          onClick={handleSave}
          color="primary"
          variant="contained"
          disabled={status === -1}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ShipmentStatusPopup;
